import React, { useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faUserPlus } from '@fortawesome/free-solid-svg-icons'; 
import { getGuests, deleteGuest, addGuest } from '../actions/fieldsActions';
import { useTranslation } from 'react-i18next';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';

export const ModalShared = ({ isOpen, onClose, sharedUsers, fieldId, setSharedUsers }) => {
  const { t } = useTranslation();
  const toast = useRef(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [email, setEmail] = useState('');

  const handleInsertGuest = async () => {
    // Evitar correo duplicado
    const isAlreadyShared = sharedUsers.some(user => user.user.email === email);
    if (isAlreadyShared) {
      toast.current.show({ severity: 'error', summary: 'Error', detail: t('field.user_already_shared'), life: 6000 });
      return;
    }
    if (email === '') {
      toast.current.show({ severity: 'error', summary: 'Error', detail: t('field.empty_email'), life: 6000 });
      return;
    }
    try {
      const response = await addGuest(fieldId, email);
      if (response === 200) {
        const guestsResponse = await getGuests(fieldId);
        setSharedUsers(guestsResponse.results);
        setErrorMessage('');
        setEmail('');
      } else if (response === 404) {
        toast.current.show({ severity: 'error', summary: 'Error', detail: t('field.user_not_found'), life: 6000 });
      } else {
        toast.current.show({ severity: 'error', summary: 'Error', detail: t('field.error_adding_user'), life: 6000 });
      }
    } catch (error) {
      console.error(error);
      toast.current.show({ severity: 'error', summary: 'Error', detail: t('field.error_adding_user'), life: 6000 });
    }
  };

  const handleDeleteGuest = async (userId) => {
    try {
      const response = await deleteGuest(fieldId, userId);
      if (response.status === 200) {
        setSharedUsers(prevUsers => prevUsers.filter(user => user.user.id !== userId));
      } else {
        console.error('Error deleting user:', response.statusText);
      }
    } catch (error) {
      console.error('Error deleting user:', error);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      {/* El Toast se mantiene con stopPropagation para evitar efectos no deseados */}
      <div onClick={(e) => e.stopPropagation()}>
        <Toast 
          ref={toast}
          style={{ zIndex: 1 }}
          position="top-center" 
          className="w-11" 
        />
      </div>

      {/* Overlay sin onClick que cierre el modal */}
      <div 
        className="w-full h-full flex justify-content-center align-items-center fixed top-0 left-0 right-0 bottom-0 bg-black-alpha-40" 
        style={{ zIndex: 2 }}
        onClick={(e) => e.stopPropagation()}  // Aquí evitamos el cierre del modal al pulsar en el overlay
      >
        {/* Caja de contenido: Detenemos la propagación para que el modal no se cierre si se hace clic dentro */}
        <div
          className="w-11 bg-white p-3 border-round-2xl shadow-2 text-center desktop-max-width"
          onClick={(e) => e.stopPropagation()}
          style={{ outline: 'none' }} // Opcional: evita el efecto azul de foco
          tabIndex={-1}
        >
          <div className="flex justify-content-between align-items-center mb-3">
            <h2 className="m-0 text-color-secondary">{t('field.shared_users')}</h2>
            <span
              className="text-color-secondary"
              style={{ cursor: 'pointer', fontSize: '2.5rem', fontWeight: 'bold' }}
              onClick={onClose} // Aquí se cierra el modal al pulsar en la X
            >
              &times;
            </span>
          </div>
          {errorMessage && <strong><p className="error-message">{errorMessage}</p></strong>}
          <div className="relative flex align-items-center w-full">
            <InputText
              className="flex-1 p-2 pr-4 border-1 border-round-sm text-base"
              type="text"
              id="email"
              name="email"
              placeholder={t('field.enter_user_email')}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ outline: 'none' }} // Opcional: evitar el foco visual
            />
            <span
              className="text-primary"
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                textDecoration: 'underline'
              }}
              onClick={handleInsertGuest}
            >
              {t('field_card.link')}
            </span>
          </div>

          <div className="flex flex-column pl-2" style={{ marginTop: '10px', paddingRight: '10.6px' }}>
            {sharedUsers.length > 0 ? (
              sharedUsers.map((user) => (
                <div
                  key={user.user.id}
                  className="flex justify-content-center align-items-center"
                  style={{ flexWrap: 'nowrap' }}
                >
                  <p
                    style={{
                      color: 'black',
                      flex: '1',
                      minWidth: 0,
                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                      textAlign: 'start',
                      paddingRight: '3px',
                      marginTop: '10px',
                      marginBottom: '10px'
                    }}
                  >
                    {user.user.email}
                  </p>
                  <span
                    className="text-primary"
                    style={{
                      cursor: 'pointer',
                      textDecoration: 'underline'
                    }}
                    onClick={() => handleDeleteGuest(user.user.id)}
                  >
                    {t('field_card.unlink')}
                  </span>
                </div>
              ))
            ) : (
              <p className="text-color-secondary">{t('field.no_shared_users')}</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
